import { Component, OnInit } from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";

@Component({
  selector: 'app-asahshome',
  templateUrl: './asahshome.component.html',
  styleUrls: ['./asahshome.component.scss']
})
export class AsahshomeComponent implements OnInit {

  constructor(private meta: Meta,
              private titles: Title) { }

    ngOnInit(): void {
        window.scrollTo(0, 0);

        this.updateMetaTags();
    }

    updateMetaTags() {
        this.titles.setTitle('Allied Health Science Courses at ARNI School of Health');
        this.meta.updateTag({
            name: 'description',
            content: `Discover allied health science courses at ARNI School of Allied Health Sciences. Gain essential skills and knowledge for a rewarding career in healthcare.`
        });
    }

}
